import React, { useEffect, useState } from "react"
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Modal, Dropdown, DropdownButton } from 'react-bootstrap'

import { httpOk, GET, POST } from 'helpers/api'

// Импортируем dnd-kit
import { DndContext, useDraggable, useDroppable, DragOverlay, PointerSensor, useSensor, useSensors } from '@dnd-kit/core';

function Index() {
	const { t } = useTranslation()

	const reduxAccount = useSelector(state => state.account)

	const [data, setData] = useState([])
	const [poses, setPoses] = useState([])
	const [menus, setMenus] = useState([])
	const [activePage, setActivePage] = useState(null)
	const [selectedItem, setSelectedItem] = useState([])
	const [openMenus, setOpenMenus] = useState({}); // key = item.id, value = true/false
	const [activeProduct, setActiveProduct] = useState(null); // Для хранения тащимого продукта
	const [modalMenuCopy, setModalMenuCopy] = useState(false); // Для хранения тащимого продукта
	const [modalPageName, setModalPageName] = useState({ 'bool': false, 'name': '', 'index': null })

	async function createUpdate() {
		if (!data?.data) return;
		const payload = { pages: data.data };

		const response = await POST('/quick-menu', payload, { loader: true, notification: true });

		if (httpOk(response)) getData(); // обновляем с бэка после сохранения
	}

	async function createMenuCopy() {
		var posIds = []

		for (let i = 0; i < poses.length; i++) {
			if (poses[i]['selected']) posIds.push(poses[i]['id']);
		}

		const response = await POST('/quick-menu-copy', {
			'to_pos_ids': posIds
		}, { loader: true, notification: true });

		if (httpOk(response)) toggleCopyMenuModal()
	}

	function clearCell(cell) {
		var cellId = cell.id
		setData(prev => {
			const updatedPages = prev.data.map((page, idx) => {
				if (idx === activePage) {
					return {
						...page,
						cells: page.cells.map(cell =>
							cell.id === cellId ? { ...cell, item: null } : cell
						)
					};
				}
				return page;
			});

			setSelectedItem(updatedPages[activePage]);
			return { ...prev, data: updatedPages };
		});
	}

	function changePageName() {
		const dataCopy = JSON.parse(JSON.stringify(data));

		dataCopy.data[modalPageName.index].name = modalPageName.name;

		setData(dataCopy);

		// обновляем выбранную страницу чтобы кнопки перерисовались
		setSelectedItem(dataCopy.data[modalPageName.index]);

		toggleModalPage();
	}

	function toggleCopyMenuModal(bool = false) {
		if (bool && !poses.length) getPoses()

		setModalMenuCopy(bool)
	}

	function toggleModalPage(bool = false, item = {}, index = null) {
		setModalPageName({
			...modalPageName,
			'bool': bool,
			'name': item.name ?? "",
			'index': index,
		})
	}

	function toggleMenu(id) {
		setOpenMenus(prev => ({
			...prev,
			[id]: !prev[id]
		}));
	};

	function handleSelectPage(item, index) {
		setActivePage(index)
		setSelectedItem({ ...item })
	}

	function handleSelectPos(e, index) {
		var posesCopy = [...poses]

		posesCopy[index]['selected'] = e.target.checked

		setPoses(posesCopy)
	}

	// 1. Улучшенный компонент продукта
	function DraggableProduct({ item }) {
		const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
			id: `product-${item.product_id}`,
			data: { product: item }
		});

		const style = {
			opacity: isDragging ? 0.3 : 1,
			cursor: "grab",
			background: "var(--dark-surface, white)",
			userSelect: "none",
			touchAction: "none"
		};

		return (
			<div ref={setNodeRef} style={style} {...listeners} {...attributes}>
				{item.name}
			</div>
		);
	}

	// Настройка сенсоров, чтобы клики по кнопкам не блокировались
	const sensors = useSensors(
		useSensor(PointerSensor, {
			activationConstraint: {
				distance: 5, // Начинать тащить только после сдвига на 5px
			},
		})
	)

	const handleDragStart = (event) => {
		// Сохраняем данные продукта, который начали тащить
		setActiveProduct(event.active.data.current.product);
	}

	// Компонент ячейки (Droppable)
	function DroppableCell({ cell }) {
		const { isOver, setNodeRef } = useDroppable({
			id: `cell-${cell.id}`,
			data: { cellId: cell.id }
		});

		const style = {
			height: "90px",
			background: isOver ? "var(--dark-tint-success, #bdecb6)" : "var(--dark-surface-4, #d9d9d9)", // Подсвечиваем зеленым при наведении
			borderRadius: "10px",
			transition: "background 0.2s ease",
			border: isOver ? "2px dashed #28a745" : "none",
			fontSize: "12px",
			textAlign: "center",
			position: "relative",
		};

		return (
			<div ref={setNodeRef} className="col-4">
				<div className="d-flex justify-content-center align-items-center p-2"
					style={style}>
					{cell?.item?.name || ""}
					{cell?.item?.product_id &&
						<div className="table-action-button table-action-danger-button"
							style={{
								'position': 'absolute',
								'top': '5px',
								'right': '5px',
							}}
							onClick={() => clearCell(cell)}>
							<i className="uil-times"></i>
						</div>
					}
				</div>
			</div>
		);
	}

	// Функция сохранения (Drag End)
	async function handleDragEnd(event) {
		const { over, active } = event;
		if (!over || !active) return;

		const cellId = over.data.current.cellId;
		const product = active.data.current.product;

		setData(prev => {
			const updatedPages = prev.data.map((page, idx) => {
				if (idx === activePage) {
					return {
						...page,
						cells: page.cells.map(cell =>
							cell.id === cellId ? { ...cell, item: { product_id: product.product_id, name: product.name } } : cell
						)
					};
				}
				return page;
			});

			// Обновляем selectedItem тоже, чтобы UI отобразил изменения сразу
			setSelectedItem(updatedPages[activePage]);

			return { ...prev, data: updatedPages };
		});

		setActiveProduct(null); // очищаем drag overlay
	}

	const TreeItem = ({ item, level = 0 }) => {
		const isOpen = openMenus[item.id] || false; // берем из глобального состояния
		const hasChildren = (item.children && item.children.length > 0) || (item.products && item.products.length > 0);

		return (
			<>
				<div
					className={`grid-row ${item.type === 'Группа' ? 'group-row' : ''}`}
					onClick={() => hasChildren && toggleMenu(item.id)}
					style={{ cursor: hasChildren ? 'pointer' : 'default' }}
				>
					<div className="grid-cell col-name">
						<span style={{ paddingLeft: `${level * 20}px` }}></span>
						{hasChildren ? (
							<span style={{ fontSize: '10px', marginRight: '5px', width: '12px', display: 'inline-block' }}>
								{isOpen ? '▼' : '▶'}
							</span>
						) : (
							<span style={{ width: '17px', display: 'inline-block' }}></span>
						)}
						<span className={item.type === 'Группа' ? 'fw-bold' : ''}>{item.name}</span>
					</div>
				</div>

				{isOpen && (
					<>
						{item.children?.map(child => (
							<TreeItem key={`menu-${child.id}`} item={{ ...child, type: 'Группа' }} level={level + 1} />
						))}
						{item.products?.map(product => (
							<div key={`prod-${product.product_id}`} className="grid-row item-row">
								<div className="grid-cell col-name">
									<span style={{ paddingLeft: `${(level + 1) * 20 + 17}px` }}></span>
									<DraggableProduct
										item={{
											product_id: product.product_id || product.id,
											name: product.name
										}}
									/>
								</div>
							</div>
						))}
					</>
				)}
			</>
		);
	};

	async function getMenu() {
		const response = await GET("/helper/menu-products", {}, { loader: true })

		if (httpOk(response)) setMenus(response.data.data)
	}

	async function getPoses() {
		const response = await GET('/helper/poses', {}, { loader: true })
		if (httpOk(response)) setPoses(response.data)
	}

	async function getData() {
		var response = await GET('/quick-menu', {}, { loader: true })

		handleSelectPage(response.data.data[0], 0)
		if (httpOk(response)) setData(response.data)
	}

	useEffect(() => {
		getData()
		getMenu()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between">
				<h4 className="vertical-center">
					{t('quick_menu')}
				</h4>
				<div className="d-flex gap-2">
					<button className="btn-rounded btn btn-primary"
						onClick={createUpdate}>
						{t('save')}
					</button>
					<DropdownButton title={t('action')}>
						<Dropdown.Item onClick={() => toggleCopyMenuModal(true)}>
							{t('copy_quick_menu')}
						</Dropdown.Item>
					</DropdownButton>
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<DndContext
						sensors={sensors}
						onDragStart={handleDragStart}
						onDragEnd={handleDragEnd}>
						<div className="row">
							<div className="col-md-6">
								<div className="d-flex gap-2 mb-2">
									{data?.data?.map((item, index) => (
										<button key={index} className={`w-100 py-3 border rounded ${activePage === index ? "border-danger" : ""}`}
											style={{
												background: "#2c2c2c",
												color: "white",
												height: "90px",
												fontSize: "20px"
											}}
											onClick={() => handleSelectPage(item, index)}
											onDoubleClick={() => toggleModalPage(true, item, index)}>
											{item.name}
										</button>
									))}
								</div>

								<div className="row g-2">
									{selectedItem?.cells?.map((item, index) => (
										<DroppableCell
											key={item.id}
											cell={item}
										/>
									))}
								</div>
							</div>

							<div className="col-md-6">
								<div className="card">
									<div className="card-body p-2" style={{ height: '900px', overflowY: 'auto' }}>
										{menus?.map((item) => (
											<TreeItem
												key={item.id}
												item={{ ...item, type: "Группа" }}
												level={0}
											/>
										))}
									</div>
								</div>
							</div>
						</div>

						{/* Оверлей — это то, что летает за мышкой. Он гарантирует, что тащится только ОДИН визуальный элемент */}
						<DragOverlay dropAnimation={null}>
							{activeProduct ? (
								<div style={{
									padding: '3px 6px',
									background: 'var(--dark-surface, white)',
									border: '1px solid #28a745',
									borderRadius: '4px',
									boxShadow: '0 5px 15px rgba(0,0,0,0.2)',
									width: '200px'
								}}>
									{activeProduct.name}
								</div>
							) : null}
						</DragOverlay>
					</DndContext>
				</div>
			</div>

			{/* MODAL MENU COPY */}
			{modalMenuCopy &&
				<Modal show={modalMenuCopy} animation={false}
					size="md" centered
					onHide={() => toggleCopyMenuModal()}>
					<Modal.Header closeButton>
						<Modal.Title>{t('poses')}</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						{poses.map((item, index) => (
							<div className="d-flex justify-content-between mb-1" key={index}>
								<label className="d-flex justify-content-between w-100 cursor-pointer" style={{ cursor: 'pointer' }}>
									<p className="fw-600 vertical-center mb-0">{item.name}</p>

									<input
										type="checkbox"
										className="form-check-input"
										disabled={(item.id === reduxAccount.pos_id)}
										checked={item?.selected ?? false}
										onChange={(e) => handleSelectPos(e, index)}
									/>
								</label>
							</div>
						))}

						<div className="d-flex gap-2 mt-5 w-100">
							<button className="btn btn-warning w-100"
								onClick={() => toggleCopyMenuModal()}>
								{t('cancel')}
							</button>
							<button className="btn btn-primary w-100"
								onClick={() => createMenuCopy()}>
								{t('save')}
							</button>
						</div>
					</Modal.Body>
				</Modal>
			}
			{/* MODAL MENU COPY */}

			{/* MODAL PAGE NAME */}
			{modalPageName.bool &&
				<Modal show={modalPageName.bool} animation={false}
					size="md" centered
					onHide={() => toggleModalPage()}>
					<Modal.Header closeButton>
						<Modal.Title>{t('name2')}</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div className="form-group">
							<label>{t('name2')}</label>
							<input type="text" className="form-control"
								name="name"
								autoComplete="off"
								value={modalPageName.name}
								onChange={(e) => setModalPageName({ ...modalPageName, 'name': e.target.value })} />
						</div>

						<div className="d-flex gap-2 w-100">
							<button className="btn btn-warning w-100"
								onClick={() => toggleModalPage()}>
								{t('cancel')}
							</button>
							<button className="btn btn-primary w-100"
								onClick={() => changePageName()}>
								{t('save')}
							</button>
						</div>
					</Modal.Body>
				</Modal>
			}
			{/* MODAL PAGE NAME */}
		</>
	)
}

export default Index